<template>
    <div>
        <div class="loading" v-if="loading"></div>
        <div v-else>
            <div class="tile is-ancestor mb-5">
                <div class="tile is-parent is-flex is-flex-wrap-wrap gap">
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <div class="is-flex is-flex-direction-column">
                                <b>Countries</b>
                            </div>
                            <span class="count">{{ stats.numCountries }}</span>
                        </div>
                    </div>
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <div class="is-flex is-flex-direction-column">
                                <b>Offices</b>
                                <a href="https://www.boyden.com/offices/index.html#subnav" target="_blank">
                                    View more
                                </a>
                            </div>
                            <span class="count">{{ stats.numOffices }}</span>
                        </div>
                    </div>
                    <!-- <div class="tile is-child is-2">
						<div class="card fit-height">
							<div class="card-content">
								<b>Lines of Business</b>
								&nbsp;
								<span>{{ stats.numLines }}</span>
							</div>
						</div>
					</div> -->
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <div class="is-flex is-flex-direction-column">
                                <b>Practice Groups</b>
                                <a href="https://www.boyden.net/practices" target="_blank">View more</a>
                            </div>
                            <span class="count">{{ stats.numPG }}</span>
                        </div>
                    </div>
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <b>Subsectors</b>
                            <span class="count">{{ stats.numSS }}</span>
                        </div>
                    </div>
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <b>Partners</b>
                            <span class="count">{{ stats.numPartners }}</span>
                        </div>
                        <div class="mt-2">
                            <o-button icon-left="user" @click="OpenReport('_ReportsUsers', 'partner')">Directory Report</o-button>
                        </div>
                    </div>
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <b>Researchers</b>
                            <span class="count">{{ stats.numResearchers }}</span>
                        </div>
                        <div class="mt-2">
                            <o-button icon-left="user" @click="OpenReport('_ReportsUsers', 'researcher')">Directory Report</o-button>
                        </div>
                    </div>
                    <div class="item-count-tile tile is-3 is-flex-direction-column">
                        <div class="flex-full-width">
                            <b>Admins</b>
                            <span class="count">{{ stats.numAdmins }}</span>
                        </div>
                        <div class="mt-2">
                            <o-button icon-left="user" @click="OpenReport('_ReportsUsers', 'admin')">Directory Report</o-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="company-explorer-footer mt-5">
                View our offices on
                <a href="https://www.boyden.com/offices/index.html#subnav" target="_blank">boyden.com</a>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, computed, inject, onMounted } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";

export default {
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            }
        },
        showHeader: {
            type: Boolean,
            default: true
        }
    },
    setup(props, context) {
        const http = inject("$http");
        const error = inject("$error");
        const moment = inject("$moment");
        const router = useRouter();

        const loading = ref(true);
        const rows = ref(props.items);
        const stats = ref({});
        const selected = ref({});

        const Select = (row) => {
            selected.value = row;
        };

        const GetData = async () => {
            try {
                const response = await http.get("/api/v2/widget/companyExplorer");
                stats.value = response.data;
                rows.value = stats.value.global[0].children;
                return response.data;
            } catch (err) {
                console.error(err);
            }
        };

        const ExtractRowsByLocationType = (locationType) => {
            return _ExtractRowsByLocationType(stats.value.global, locationType);
        };
        const _ExtractRowsByLocationType = (filteredRows, locationType) => {
            let rows = [];
            for (const i in filteredRows) {
                const row = filteredRows[i];
                if (row.LocationType == locationType || !locationType) rows.push(row);
                rows = rows.concat(_ExtractRowsByLocationType(row.children, locationType));
            }
            return rows;
        };

        const TryGetIdByName = async (filteredRows, filterType) => {
            try {
                const response = await http.post(
                    `/api/v2/widget/companyExplorer/filter?filterType=${filterType}`,
                    filteredRows
                );
                return response.data;
            } catch (err) {
                console.error(err);
            }
        };

        const OpenReport = async (reportType, tileName) => {
            const filterDates = {
                startDate: moment.utc().subtract(1, "year").toDate(),
                endDate: moment.utc().toDate(),
                selection: "1Y"
            };
            let filters = [];
            if (reportType == "_ReportsUsers") {
                filters.push({
                    key: { Id: "UserStatus", Text: "User Status" },
                    value: {
                        Id: "1",
                        Text: "Active"
                    }
                });
            }

            switch (tileName) {
                case "subsector":
                case "practiceGroup": {
                    let key = { Id: "ReportGroupId", Text: "Report Group" };
                    if (reportType == "_ReportsUsers") {
                        key = { Id: "Groups", Text: "Group" };
                    }

                    let rows = ExtractRowsByLocationType();
                    rows = await TryGetIdByName(rows, tileName);
                    filters = filters.concat(
                        rows.map((row) => {
                            return {
                                key: key,
                                value: {
                                    Id: row.Id,
                                    Text: row.Name
                                }
                            };
                        })
                    );
                    break;
                }
                case "country": {
                    let rows = ExtractRowsByLocationType("country");
                    rows = await TryGetIdByName(rows, "country");
                    filters = filters.concat(
                        rows.map((row) => {
                            return {
                                key: { Id: "LicenseId", Text: "License" },
                                value: {
                                    Id: row.Id,
                                    Text: row.Title
                                }
                            };
                        })
                    );
                    break;
                }
                case "office": {
                    let rows = ExtractRowsByLocationType("city");
                    rows = await TryGetIdByName(rows, "city");
                    filters = filters.concat(
                        rows.map((row) => {
                            return {
                                key: { Id: "LocationId", Text: "Location" },
                                value: {
                                    Id: row.Id,
                                    Text: row.Title
                                }
                            };
                        })
                    );
                    break;
                }
                case "partner": {
                    filters = filters.concat([
                        {
                            key: { Id: "Role", Text: "Role" },
                            value: {
                                Id: "Partner",
                                Text: "Partner"
                            }
                        }
                    ]);
                    break;
                }
                case "researcher": {
                    filters = filters.concat([
                        {
                            key: { Id: "Role", Text: "Role" },
                            value: {
                                Id: "Researcher",
                                Text: "Researcher"
                            }
                        }
                    ]);
                    break;
                }
                case "admin": {
                    filters = filters.concat([
                        {
                            key: { Id: "Role", Text: "Role" },
                            value: {
                                Id: "Administrator",
                                Text: "Administrator"
                            }
                        }
                    ]);
                    break;
                }
            }

            store.dispatch("setParams", {
                dates: filterDates,
                keys: filters,
                autoRun: true
            });

            router.push({
                name: reportType
            });
        };

        onMounted(async () => {
            try {
                const promises = [];
                if (rows.value.length == 0) promises.push(GetData());

                await Promise.all(promises);

                loading.value = false;
            } catch (err) {
                error("Failed to load explorer.");
                console.log(err);
            }
        });

        return {
            loading,
            stats,
            rows,
            selected,
            Select,
            OpenReport
        };
    }
};
</script>
<style lang="scss">
.tile.gap {
    gap: 10px;

    &>.is-child {
        margin-bottom: 10px;
    }
}

.large {
    font-size: 120%;
}

.tooltip-size>.tooltip-content {
    min-width: 200px;
    min-height: 200px;
    background: #efefef !important;
}

.default-cursor {
    cursor: default;
}

.card.fit-height {
    height: 100%;
}

.box {
    border: 1px solid #efefef;
    cursor: pointer;
    margin: 2px;
}

.box.selected {
    background-color: #dfdfdf;
}

.count {
    float: right;
    font-size: 1.6em;
}

.flex-full-width {
    display: flex;
    width: 100%;
    justify-content: space-between;
}
</style>
